export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/more.a8d0662e.svg","height":42,"width":34,"blurWidth":0,"blurHeight":0};